import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../../Resolve';

const states: Ng1StateDeclaration[] = [
    {
        name: 'passwordChange',
        url: '/passwordChange',
        component: 'wtUserPasswordChange',
        resolve: {
            auth: Resolve.authResolve,
        },
        data: {
            visible: false,
            icon: 'fa-users',
            displayName: 'Change user password',
            editRoles: [],
            editButtonVisibility: () => false,
            ignoreHistory: true
        }
    }];

export default states;